import React, { useState, useEffect } from 'react';
import { MDBCol, MDBRow } from 'mdbreact';
import PropTypes from 'prop-types';

import { actionSvgs } from 'assets/icons';

import ContentLoader from 'components/Informations/Loaders/ContentLoader';
import PageStructure from 'components/PageStructure';
import If from 'components/If';
import { renderToast } from 'components/Informations/Toast/utils';

import useFetch from 'hooks/useFetch';
import endpoints from 'services/endpoints';

import EditPrivilege from '../InternalComponents/EditPrivilege';

import privilegesData from './privileges.data';
import * as S from './styles';

const { getPrivilegesData } = endpoints;

export default function ManagePrivileges({ user }) {
  const { id_funcionario: userID } = user;

  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [overlayData, setOverlayData] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [toastVisibility, setToastVisibility] = useState(false);
  const [toastInfos, setToastInfos] = useState({
    type: '',
    message: '',
    autoClose: 6000,
  });

  const [isLoading, setIsLoading] = useState(true);

  const [privilegesObserver, setPrivilegesObserver] = useState(false);
  const [privilegesByFunction, privilegesLoading] = useFetch(
    getPrivilegesData,
    privilegesObserver,
  );

  function getRoutesAccessNames(permissionIds) {
    const routeNames = privilegesData
      .flat()
      .map(({ routes }) => routes)
      .flat()
      .filter(route => permissionIds.includes(route.permissionId));

    return (
      routeNames.map(({ route }) => route).join(', ') ||
      'Nenhum acesso atribuído'
    );
  }

  useEffect(() => {
    const sortedPrivilegesData = privilegesByFunction?.sort((a, b) =>
      a.nome_funcao > b.nome_funcao ? 1 : -1,
    );
    setTableData(sortedPrivilegesData);
    setIsLoading(false);
  }, [privilegesByFunction]);

  function handlePrivilegeEdit(item) {
    setIsOverlayOpen(true);
    setOverlayData({
      permissions: item.acessos,
      funcao: item.nome_funcao,
      id_funcao: item.id_funcao,
      userID,
    });
  }

  return (
    <>
      {toastVisibility &&
        renderToast(
          toastInfos.type,
          toastInfos.message,
          toastInfos.autoClose,
          setToastVisibility,
        )}

      <PageStructure
        title="Gerência de privilégios"
        subtitle="Altere as permissões de acesso do sistema às funções cadastradas"
      >
        <MDBRow>
          <MDBCol lg="12">
            <S.Table>
              <div className="table-responsive">
                <If condition>
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Nome da função</th>
                        <th scope="col">Tem acesso a</th>
                        <th scope="col">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map(item => (
                        <tr key={item.id_funcao}>
                          <td>{item.nome_funcao}</td>
                          <td>{`${getRoutesAccessNames(item.acessos)}`}</td>
                          <td>
                            <S.Button onClick={() => handlePrivilegeEdit(item)}>
                              {actionSvgs('edit', '#0083CA')}
                            </S.Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </If>
              </div>
            </S.Table>
          </MDBCol>
        </MDBRow>
      </PageStructure>

      <If condition={isOverlayOpen}>
        <EditPrivilege
          employee={overlayData}
          isOpen={isOverlayOpen}
          setIsOpen={setIsOverlayOpen}
          setIsLoading={setIsLoading}
          observer={setPrivilegesObserver}
          toastVisibility={setToastVisibility}
          toastInfos={setToastInfos}
        />
      </If>

      <If condition={isLoading || privilegesLoading}>
        <ContentLoader isFull />
      </If>
    </>
  );
}

ManagePrivileges.defaultProps = {
  user: {},
};

ManagePrivileges.propTypes = {
  user: PropTypes.shape(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
};
